import { ComponentProps } from 'react'

import { Box } from '@chakra-ui/react'

import { useAudioRecorder } from '@/views/screens/Interview/context/AudioRecorderContext/AudioRecorderContext'

import { RecordingInProgressButton } from './components/RecordingButton'
import { RecordingMenu } from './components/RecordingMenu'
import { useRecordingModals } from './hooks/useRecordingModals'
import { AudioRecorderProps } from './types'

type Props = AudioRecorderProps & ComponentProps<typeof Box>

export const AudioRecorder = ({ onRecordingFinished, ...props }: Props) => {
  const { ModalComponent, handleMicClick, handleTabClick } =
    useRecordingModals()

  const {
    isRecording,
    selectedLiveTranscriptionProvider,
    setSelectedLiveTranscriptionProvider,
  } = useAudioRecorder()

  return (
    <>
      <Box {...props}>
        {ModalComponent}
        {isRecording ? (
          <RecordingInProgressButton />
        ) : (
          <RecordingMenu
            onMicClick={handleMicClick}
            onTabClick={handleTabClick}
            selectedProvider={selectedLiveTranscriptionProvider}
            onProviderChange={setSelectedLiveTranscriptionProvider}
          />
        )}
      </Box>
    </>
  )
}
